import request from "@/utils/request"

export default function agentGetWithdrawLogPage(params, pageNum = 1, size = 10) {
    return request({
        url: `/fund/withdrawLog/agentGetWithdrawLogPage/${pageNum}/${size}`,
        params: params
    })
}
